import { render, staticRenderFns } from "./switchLive.vue?vue&type=template&id=77db3e88&scoped=true&"
import script from "./switchLive.vue?vue&type=script&lang=ts&"
export * from "./switchLive.vue?vue&type=script&lang=ts&"
import style0 from "./switchLive.vue?vue&type=style&index=0&id=77db3e88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db3e88",
  null
  
)

export default component.exports